import React from 'react';

import { ErrorLabel } from '@eika/label';

import { Valideringstype } from '../../types/generated-types';
import { getFeilmeldingFrom } from '../reducer/valideringstype';
import { ObjektAlternativ } from './forsikring-objekter-checkbox-types';

interface ObjekterCheckboxFeilmeldingProps {
    objekter: ObjektAlternativ[];
}

export const ObjekterCheckboxFeilmelding = ({ objekter }: ObjekterCheckboxFeilmeldingProps) => {
    const atLeastOneSelected = objekter !== undefined && objekter.filter((alternativ) => alternativ.checked).length > 0;
    if (!atLeastOneSelected) {
        return (
            <ErrorLabel text={getFeilmeldingFrom(Valideringstype.Pakrevd)} className="checkbox-feilmelding-wrapper" />
        );
    }
    return null;
};
